import React from 'react'
import MessageUI from '../output/MessageUI'
import './InputField.css'

const InputFieldUI = ({context, className, name, required, label, help, messageList, labelKey, helpKey, children}) =>
  <div className={`w_input_fld ${className ? className : ''} ${required ? 'required' : ''} ${name}`}>
    {
      label &&
      <label>{label}</label>
    }
    {
      labelKey &&
      <label>
        <MessageUI messageList={messageList} messageKey={labelKey} />
      </label>
    }
    {children}
    {
      help &&
      <div className='help g_muted'>{help}</div>
    }
    {
      helpKey &&
      <div className='help g_muted'>
        <MessageUI messageList={messageList} messageKey={helpKey} />
      </div>
    }
  </div>

export default InputFieldUI
